import React, { ReactElement } from 'react';
import { css } from '@emotion/css';
import { color_colors_ocean, color_text_light } from '../../constants/colors';
import HistogramChart from './HistogramChart';
import SecondaryLoader from '../general/SecondaryLoader';

const primaryIndicator = require('../../content/images/analytics-icons/histogram-primary-indicator.svg');
const secondaryIndicator = require('../../content/images/analytics-icons/histogram-secondary-indicator.svg');

interface HistogramChartProps {
    title: string
    subtitle?: string
    primaryDataName?: string
    secondaryDataName?: string
    data: { x: string, y: number, color: string, fullDate: string, link?: string }[]
    secondaryData: { x: string, y: number, color: string, fullDate: string, link?: string }[]
    showSecondary: boolean
    showPrimary: boolean
    isLoading?: boolean
    filterButton?: ReactElement
    titlePadding?: { top: number, right: number, bottom: number, left: number }
    titleMargin?: { top: number, right: number, bottom: number, left: number }
    graphPadding?: number
    graphBottomPadding?: number
    titleStyle?: string
}
export const HistogramChartCard: React.SFC<HistogramChartProps> = (props) => {

    const containerStyle = css`
    height: 468px;
    width: auto;
    font-family: Muli;
    border: 1px solid #CBCCD2;
    box-sizing: border-box;
    border-radius: 8px;
    flex: 1;
    background: white;
    .loader-container {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        .spinner > div {
            background: ${color_colors_ocean};
        }
    }

    .title-section {
        display: flex;
        align-items: center;
        margin: ${props.titleMargin ? `${props.titleMargin.top}px ${props.titleMargin.right}px ${props.titleMargin.bottom}px ${props.titleMargin.left}px` : '0px 0px 24px 0px'};
        padding: ${props.titlePadding ? `${props.titlePadding.top}px ${props.titlePadding.right}px ${props.titlePadding.bottom}px ${props.titlePadding.left}px` : '16px'};
        .title-label {
            font-size: 18px;
            line-height: 24px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: ${color_text_light};
            margin: 0;
            text-align: center;
        }

        .legend-container {
            display: flex;
            align-items: center;
            margin-right: 0;
            margin-left: auto;

            >img {
                margin-right: 8px;
            }
            >p {                
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                text-align: right;
                margin-right: 16px;
            }
        }
    }
    
    .subtitle-section {
        display: flex;
        align-items: center;
        margin-top: -7px;
        padding: 0px 36px;
        margin-left: -7px;
        h4 {
            font-style: normal;
            font-weight: normal;
            font-color: ${color_text_light};
            font-size: 12px;
            line-height: 18px;
            flex: 1;
        }
    }
`

    return (
        <div className={containerStyle}>
            <div className="title-section ac-analytics-histogram-card">
                <h5 className={props.titleStyle || "title-label"}>{props.title}</h5>
                <div className="legend-container">
                    {props?.filterButton === undefined ? (<>
                        {props.showSecondary && <>
                            <img src={secondaryIndicator} />
                            <p>{props.secondaryDataName}</p>
                        </>}
                        {props.showPrimary && <>
                            <img src={primaryIndicator} />
                            <p>{props.primaryDataName}</p>
                        </>}
                    </>) : props.filterButton}
                </div>
            </div>
            <div className="subtitle-section ac-analytics-histogram-card">
                <h4>{props.subtitle}</h4>
            </div>
            {props.isLoading
                ? <div className="loader-container"><SecondaryLoader /></div>
                : <HistogramChart data={props.showPrimary ? props.data : null} secondaryData={props.showSecondary ? props.secondaryData : null} primaryDataName={props.primaryDataName} secondaryDataName={props.secondaryDataName} padding={props.graphPadding} paddingBottom={props.graphBottomPadding} />}
        </div>
    )
}

export default HistogramChartCard;